module.exports = __webpack_public_path__ + "img/comic5.jpg";